import React from 'react';
import Timeline from './Timeline';

export default function ResumeSection({ homeData }) {
  return (
    <section class='resume-section'>
      <div class='row'>
        <div class='col-lg-12'>
          {/* <h6 class="section-subtitle">RESUME</h6> */}
          <h2 class='section-title'>Education</h2>
          {homeData && <Timeline content={homeData['education']} />}
        </div>
        <div class='col-lg-12'>
          {/* <h6 class="section-subtitle">RESUME</h6> */}
          <h2 class='section-title'>Experience</h2>
          {homeData && <Timeline content={homeData['experience']} />}
        </div>
      </div>
    </section>
  );
}
